import { Link } from 'react-router-dom';
import { JabalipuraanLogo } from '../common/JabalipuraanLogo';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-primary-foreground" data-testid="footer">
      {/* Gold line divider */}
      <div className="h-px bg-accent"></div>
      
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <JabalipuraanLogo 
              size="lg" 
              showText={true}
              textClassName="text-primary-foreground"
              linkTo="/"
            />
            <p className="font-accent text-lg italic text-primary-foreground/80 mt-4 mb-4">
              "Heritage by Jabalpuriyas, for Jabalpuriyas, and of Jabalpuriyas."
            </p>
            <p className="text-sm text-primary-foreground/60 max-w-md">
              A citizen-led digital heritage platform documenting, preserving, and publicly 
              activating the historical, cultural, and social narratives of Jabalpur.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4 text-accent">
              Explore
            </h4>
            <ul className="space-y-2">
              {[
                { href: '/about', label: 'About Us' },
                { href: '/articles', label: 'Articles' },
                { href: '/initiatives', label: 'Initiatives' },
                { href: '/media', label: 'Media Coverage' },
              ].map((link) => (
                <li key={link.href}>
                  <Link 
                    to={link.href}
                    className="text-sm text-primary-foreground/70 hover:text-accent transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4 text-accent">
              Connect
            </h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/contact"
                  className="text-sm text-primary-foreground/70 hover:text-accent transition-colors duration-300"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/register"
                  className="text-sm text-primary-foreground/70 hover:text-accent transition-colors duration-300"
                >
                  Create Free Account
                </Link>
              </li>
            </ul>
            <p className="text-xs text-primary-foreground/50 mt-4 italic">
              Free, open access for all readers.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-primary-foreground/50">
              © {currentYear} Jabalipuraan. All rights reserved.
            </p>
            <p className="text-xs text-primary-foreground/40 text-center md:text-right">
              A public heritage initiative · Community-supported · Open access
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
